var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { attrs: { id: "setting-container" } },
      [
        _c(
          "b-row",
          [
            _c("b-col", { attrs: { cols: "12" } }, [
              _vm.board
                ? _c(
                    "div",
                    [
                      _c("jBoardForm", {
                        ref: "refBoardForm",
                        attrs: { board: _vm.board, mode: "update" },
                        on: { getData: _vm.getBoardFormData }
                      }),
                      _vm._v(" "),
                      _c(
                        "b-button",
                        {
                          staticClass: "btn blue",
                          on: { click: _vm.updateBoard }
                        },
                        [_vm._v("\n            Update\n          ")]
                      )
                    ],
                    1
                  )
                : _vm._e()
            ])
          ],
          1
        ),
        _vm._v(" "),
        _c("br")
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4f0cdea7", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4f0cdea7","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/board/tabs/jBoardGeneralTab.vue
// module id = null
// module chunks = 